import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Groups as GroupsIcon } from "@mui/icons-material";
import { Box, Typography } from "@mui/material";
import { EmptyState } from "../common/EmptyState";
import { EntityListCard } from "../common/EntityListCard";
import { PlayerListRow } from "../players/PlayerListRow";
import { PlayerMatchStatGlyphs } from "../stats/PlayerMatchStatGlyphs";
import { AddButton, ManageButton, SeeAllButton } from "../utils/CardActions";
import { CardFooterLink } from "../utils/CardFooterLink";
const MAX_PLAYERS_TO_SHOW = 5;
export const SquadCard = ({ players, teamId, title, canModify = false, getPlayerStat, }) => {
    // isActive only exists on roster members; a match squad (no teamId) may include
    // summary-only players (e.g. someone who has since left the team).
    const activePlayers = teamId
        ? players.filter((p) => "isActive" in p && p.isActive)
        : players;
    const truncate = !!teamId;
    const showViewAll = truncate && activePlayers.length > MAX_PLAYERS_TO_SHOW;
    const playersToDisplay = truncate
        ? activePlayers.slice(0, MAX_PLAYERS_TO_SHOW)
        : activePlayers;
    return (_jsx(EntityListCard, { title: title, heading: "Squad", count: activePlayers.length, headerAction: teamId &&
            (canModify ? (_jsxs(Box, { sx: { display: "flex", alignItems: "center" }, children: [_jsx(AddButton, { to: `/teams/${teamId}/add-player/`, title: "Add player" }), _jsx(ManageButton, { to: `/teams/${teamId}/squad/` })] })) : (showViewAll && _jsx(SeeAllButton, { to: `/teams/${teamId}/squad/` }))), items: playersToDisplay, renderRow: (player, index, items) => (_jsx(PlayerListRow, { player: player, showDivider: index < items.length - 1, trailing: getPlayerStat ? (_jsx(PlayerMatchStatGlyphs, { ...(getPlayerStat(player.id) ?? {}) })) : undefined, leading: _jsx(Box, { sx: {
                    width: 28,
                    textAlign: "center",
                    mr: 1.5,
                    flexShrink: 0,
                }, children: _jsx(Typography, { variant: "body2", sx: {
                        fontWeight: 600,
                        lineHeight: 1,
                        color: "text.secondary",
                    }, children: "squadNumber" in player &&
                        player.squadNumber !== null &&
                        player.squadNumber !== undefined
                        ? player.squadNumber
                        : "–" }) }) }, player.id)), emptyState: _jsx(EmptyState, { icon: _jsx(GroupsIcon, {}), heading: "No players yet", description: "Add players to build your squad" }), footer: teamId && (_jsx(CardFooterLink, { to: `/teams/${teamId}/formation/`, label: "Build a Formation \u2192" })) }));
};
